import { Pipe, PipeTransform } from '@angular/core';
import { ContentStatus } from '../enums/content-status';

@Pipe({
  name: 'contentStatusDescription',
})
export class ContentStatusDescriptionPipe implements PipeTransform {
  transform(value: any, ...args: any[]): string {
    if (typeof value !== 'string') {
      return 'Unknown Status';
    }

    const statusDescriptions: Record<ContentStatus, string> = {
      [ContentStatus.NEW]: 'New',
      [ContentStatus.SPIKED]: 'Spiked',
      [ContentStatus.READ_ONLY]: 'Read Only',
      [ContentStatus.WRITING]: 'Writing',
      [ContentStatus.PUBLISHED]: 'Published',
      [ContentStatus.WAITING_FOR_EDITING]: 'Waiting for Editing',
      [ContentStatus.EDITING]: 'Editing',
      [ContentStatus.WAITING_FOR_JOURNALIST_EDITING]:
        'Waiting for Journalist Editing',
      [ContentStatus.JOURNALIST_EDITING]: 'Journalist Editing',
      [ContentStatus.WAITING_FOR_SUBEDITING]: 'Waiting for Sub-editing',
      [ContentStatus.SUBEDITING]: 'Sub-editing',
      [ContentStatus.SUBEDITOR_APPROVED]: 'Sub-editor Approved',
    };

    return statusDescriptions[value] || 'Unknown Status';
  }
}
